import { lxMV } from './lx'
import { I_AGENT } from './agent/typing'

function nativeAgentClass(Agent: I_AGENT) {
  if (!Agent.native) return ['not-native']
  const classList = ['native']
  Agent.meituan && classList.push('native-meituan')
  Agent.dianping && classList.push('native-dianping')
  if (Agent.iphone) {
    classList.push('native-ios')
    if (Agent.ltios11) {
      classList.push('native-ltios11')
    }
  }
  if (Agent.android) {
    classList.push('native-android')
  }
  return classList
}

// 添加dpr类名
function dprClass() {
  const devicePixelRatio = window.devicePixelRatio || 1
  return devicePixelRatio >= 2 ? 'dpr-2' : 'dpr-1'
}

function gridClass() {
  let gridSupported = typeof document.createElement('div').style.grid === 'string'
  lxMV(gridSupported ? 'b_airbnb_9m9ofsqt_mv' : 'b_airbnb_78un84kf_mv')
  if (window.location.href.indexOf('nogrid') !== -1) gridSupported = false
  const layout = getComputedStyle(document.body, '::before').content.trim()
  const unSupportedClass = layout === '"max-width"' ? 'm-grid-unsupported' : 'grid-unsupported'
  return gridSupported ? 'grid-supported' : unSupportedClass
}

// 用于添加一些全局 class 用于样式配置
export default function addAgentClass(Agent: I_AGENT) {
  const el = document.querySelector('html') as HTMLElement
  const classList = []
  classList.push(...nativeAgentClass(Agent))
  if (!Agent.native && Agent.iphone) {
    el.setAttribute('enable-safe-area', 'true')
  }
  if (Agent.iphone) {
    classList.push('plat-ios')
  }
  if (Agent.android) {
    classList.push('plat-android')
  }
  if (Agent.iphonex) {
    classList.push('iphonex')
  }
  if (Agent.weixin) {
    classList.push('weixin')
  }
  if (Agent.anyminiprogram) {
    classList.push('miniprogram')
  }
  if (Agent.pc) {
    classList.push('plat-pc')
  }
  classList.push(gridClass())
  classList.push(dprClass())
  // console.log('[classList]', classList.join(' '))
  el.classList.add(...classList)
  return classList.join(' ')
}
